"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var deviceAtmosphere_type_1 = require("./deviceAtmosphere.type");
// Type guards
exports.isKpiAtmosphereE4000 = function (kpiAtmosphere) { return deviceAtmosphere_type_1.isGCE4000(kpiAtmosphere.deviceId); };
exports.isKpiAtmosphereERSC02 = function (kpiAtmosphere) { return deviceAtmosphere_type_1.isGCERSC02(kpiAtmosphere.deviceId); };
